module.exports = __webpack_public_path__ + "img/button_anotovanie.cf7c95a1.svg";